// extracted by mini-css-extract-plugin
export default {"menu":"NavBar_menu__yZMhv","transparent":"NavBar_transparent__981cK","invisibleWrapper":"NavBar_invisibleWrapper__72RjT"};